/* beautiful-react-hooks version: 0.35.0 */
var hasOwnProperty = function hasOwnProperty(obj, prop) {
  return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
};

export default hasOwnProperty;
